import React from "react";

const QueryStringContext = React.createContext();
export const QueryStringProvider = QueryStringContext.Provider;
export const QueryStringConsumer = QueryStringContext.Consumer;
export const useQueryString = () => React.useContext(QueryStringContext);

export default QueryStringContext;
